import React from "react";
import submit from "submit-form";

export const PhaseTemplateCard = ({
  template,
  index,
  selectedPhaseIndex,
  setSelectedPhaseIndex,
}) => {
  const { _id, templateName, phases } = template;
  const openEditTemplateModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        templateId: _id,
        "modal[type]": "edit-template",
      },
    });
  };

  const openRemoveTemplateModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        templateId: _id,
        "modal[type]": "remove-template",
        templateToRemove: template,
      },
    });
  };

  return (
    <div
      className={`phase-template-card${
        selectedPhaseIndex === index ? " active" : ""
      }`}
      onClick={() => setSelectedPhaseIndex(index)}
    >
      <div className="phase-info-wrapper">
        <div role="card-selector">
          {selectedPhaseIndex === index ? (
            <img src={"/img/new-icons/vuesax-linear-tick-no-background.svg"} />
          ) : null}
        </div>
        <span className="phase-template-name">{templateName}</span>
        <div className="phase-template-phases">
          {phases.map((phase, index) => (
            <div
              className="phase-template-phase"
              key={`temp-phase-card-${index}`}
            >
              <div
                style={{
                  backgroundColor: phase.phaseColor,
                }}
                className="phase-color-dot"
              />
              <span className="phase-name">{phase.phaseName}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="phase-template-card-footer">
        <button data-button-type="secondary" onClick={openEditTemplateModal}>
          Edit Template
        </button>
        <picture role="button" data-button-type="secondary">
          <img
            src="/img/new-icons/red-trash.svg"
            onClick={openRemoveTemplateModal}
          />
        </picture>
      </div>
    </div>
  );
};
